import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/ServiceVehiclesPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const ServiceVehiclesPage = observer(() => {
    const { authStore, serviceVehiclesStore } = getRootStore();
    const { dataTable, loading, filtersStore } = serviceVehiclesStore;
    const navigate = useNavigate();
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    const handleViewVehicle = (vehicleId) => {
        if (vehicleId) {
            navigate(`/service-vehicles/${vehicleId}`);
        }
        else {
            navigate("/service-vehicles/new");
        }
    };
    const handleDeleteVehicle = (vehicleId) => {
        Modal.confirm({
            title: "Удалить сервисный автомобиль?",
            content: "Вы уверены, что хотите удалить этот автомобиль?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => serviceVehiclesStore.deleteVehicle(vehicleId),
        });
    };
    const columns = [
        {
            title: "Гос. номер",
            key: "licensePlate",
            sorter: true,
            width: 150,
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewVehicle(record.id), children: record.licensePlate })),
        },
        {
            title: "Марка",
            dataIndex: "brand",
            key: "brand",
            sorter: true,
        },
        {
            title: "Модель",
            dataIndex: "model",
            key: "model",
            sorter: true,
        },
        {
            title: "Статус",
            dataIndex: "status",
            key: "status",
            sorter: true,
            render: (status) => {
                const statusColors = {
                    AVAILABLE: "green",
                    IN_USE: "blue",
                    MAINTENANCE: "orange",
                    UNAVAILABLE: "red",
                };
                return (_jsx("span", { style: { color: statusColors[status] || "default" }, children: status }));
            },
        },
        {
            title: "Текущий пробег (км)",
            dataIndex: "currentMileageKm",
            key: "currentMileageKm",
            sorter: true,
            render: (value) => value?.toLocaleString(),
        },
        {
            title: "Интервал ТО (км)",
            dataIndex: "serviceIntervalKm",
            key: "serviceIntervalKm",
            sorter: true,
            render: (value) => value?.toLocaleString(),
        },
        {
            title: "Интервал ТО (мес)",
            dataIndex: "serviceIntervalMonths",
            key: "serviceIntervalMonths",
            sorter: true,
        },
        {
            title: "Последнее ТО",
            dataIndex: "lastServiceDate",
            key: "lastServiceDate",
            sorter: true,
            render: (date) => date ? new Date(date).toLocaleDateString() : "-",
        },
        {
            title: "Пробег на ТО (км)",
            dataIndex: "lastServiceMileageKm",
            key: "lastServiceMileageKm",
            sorter: true,
            render: (value) => value?.toLocaleString() || "-",
        },
        {
            title: "Макс. заряд (кВт)",
            dataIndex: "maxChargeCapacity",
            key: "maxChargeCapacity",
            sorter: true,
            render: (value) => value || "-",
        },
        {
            title: "Текущий заряд (кВт)",
            dataIndex: "currentChargeLevel",
            key: "currentChargeLevel",
            sorter: true,
            render: (value) => value || "-",
        },
        {
            title: "Расход (кВт/км)",
            dataIndex: "kwtperkm",
            key: "kwtperkm",
            sorter: true,
            render: (value) => value || "-",
        },
        {
            title: "Действия",
            key: "actions",
            width: 80,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteVehicle(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Сервисные автомобили",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewVehicle(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 1400 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default ServiceVehiclesPage;
